import { render } from "./PanelRelatedItems.vue?vue&type=template&id=07cd23ab&scoped=true&ts=true"
import script from "./PanelRelatedItems.vue?vue&type=script&lang=ts"
export * from "./PanelRelatedItems.vue?vue&type=script&lang=ts"

import "./PanelRelatedItems.vue?vue&type=style&index=0&id=07cd23ab&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3320913318/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07cd23ab"]])

export default __exports__